// icao24Cache — maps IATA flight numbers to ICAO24 hex addresses.
// Aircraft assignments change daily so entries are keyed by flight number + date.
// One AviationStack lookup per unknown flight per day; result reused for all polls.

const CACHE_KEY = "sa_lax_icao24_cache";

function todayISO() {
  return new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"
}

function loadCache() {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
  } catch {
    return {};
  }
}

function saveCache(cache) {
  // Prune entries older than 3 days
  const cutoff = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  const pruned = Object.fromEntries(
    Object.entries(cache).filter(([key]) => {
      const date = key.split("|")[1];
      return date && date >= cutoff;
    })
  );
  localStorage.setItem(CACHE_KEY, JSON.stringify(pruned));
  return pruned;
}

// Returns cached { icao24, registration, callsign } for today, or null if not cached.
export function getCachedIcao24(flightIata) {
  const cache = loadCache();
  return cache[`${flightIata.toUpperCase()}|${todayISO()}`] ?? null;
}

// Stores a result for today.
export function setCachedIcao24(flightIata, result) {
  const cache = loadCache();
  cache[`${flightIata.toUpperCase()}|${todayISO()}`] = result;
  saveCache(cache);
}

// No-op — we intentionally don't cache "not found" results so that
// flights temporarily absent from AviationStack are retried each session.
